export default {
	name: 'Lockers',
	singular: 'Enhet',
	icon: 'warehouse',
  	ownView: 'Lockers',
	slug: 'lockers-v2',
	isCustom: true,
	access: ['superadmin', 'admin', 'reseller']
}